if (!customElements.get('ii8-faq')) {
  customElements.define(
    'ii8-faq',
    class Ii8Faq extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
      }

      select(tab) {
        this.tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
        this.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
      }
    }
  );
}
